let isSticky = false; // Flag to track if the buy-buttons are in the sticky form

const handleScroll = () => {
  const productForm = document.querySelector('.product-form');
  const buyButtons = document.querySelector('.buy-buttons');
  const stickyForm = document.querySelector('.pdp-sticky-form--sticky');
  const stickyPlaceholder = document.querySelector('.sticky-add-to-cart');

  // Get the bounding rectangle of the product form
  const rect = productForm.getBoundingClientRect();

  // Check if the product form is out of view
  if (rect.bottom < 0 && !isSticky) {
    // Show and stick the pdp-sticky-form
    stickyForm.style.display = 'block';
    stickyForm.style.position = 'fixed';
    stickyForm.style.top = '0';
    stickyForm.style.width = '100%'; // Optional: ensure it takes the full width
    //buyButtons.style.width = '80%';

    // Replace the placeholder with buy-buttons
    if (stickyPlaceholder) {
     // stickyPlaceholder.replaceWith(buyButtons);
    }

    isSticky = true; // Set the flag to indicate that buy-buttons are now sticky
  } else if (rect.bottom >= 0 && isSticky) {
    // Hide the pdp-sticky-form
    stickyForm.style.display = 'none';
    stickyForm.style.position = '';
    stickyForm.style.top = '';
/*
    // Move the buy-buttons back to its original position
    const originalContainer = document.querySelector('.product-form');
    if (originalContainer && !originalContainer.contains(buyButtons)) {
      originalContainer.appendChild(buyButtons);
      buyButtons.style.width = ''; // Reset width

      // Restore the placeholder in the sticky form
      const newPlaceholder = document.createElement('div');
      newPlaceholder.className = 'sticky-add-to-cart';
      stickyForm.appendChild(newPlaceholder);
    }
*/
    isSticky = false; // Reset the flag
  }
};

// Directly use the scroll event without debounce for immediate response
document.addEventListener('scroll', handleScroll);
